/**
 * Renders a JSON-LD structured data script tag.
 * Used for WebSite, Organization, BreadcrumbList, Product schemas.
 */
export function JsonLd({ data }: Readonly<{ data: object }>) {
  return (
    <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }} />
  );
}
